window.arjoSortDropdownModule =
  window.arjoSortDropdownModule ||
  (() => {
    const state = {
      isInitialized: false,
      elements: {},
    };

    const setUp = () => {
      const sortDropdowns = [...document.querySelectorAll('.arjo-m-sort-dropdown')];
      sortDropdowns.forEach((element) => {
        const dropdownId = element.dataset.sortDropdownId;
        if (!dropdownId) return;
        state.elements[dropdownId] = (() => {
          const innerState = {
            currentValue: element.querySelector('select').value,
          };
          const changeHandler = (e) => {
            const newValue = e.target.value;
            innerState.currentValue = newValue;
            const customEvent = new CustomEvent(`sortDropdown:${dropdownId}`, {
              detail: {
                selectedValue: newValue,
              },
            });

            window.dispatchEvent(customEvent);
          };
          element.addEventListener('change', changeHandler);
          return {
            get currentValue() {
              return innerState.currentValue;
            },
          };
        })();
      });
    };

    const init = () => {
      if (state.isInitialized) return;
      setUp();
      state.isInitialized = true;
    };

    const getElement = (id) => {
      return state.elements[id];
    };

    return { init, getElement };
  })();

window.addEventListener('load', window.arjoSortDropdownModule.init.bind(window.arjoSortDropdownModule));
